/* eslint-disable import/extensions */
import debounce from "lodash.debounce";
import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/scss";
import "./slider.scss";

// DOM element getters
const $getSlider = () => document.querySelector(".desktop-slider-fixed-height");
const $getSwiperWrapper = slider => slider.querySelector(".swiper-wrapper");
const $getSwiperSlides = slider => slider.querySelectorAll(".swiper-slide");
const SCREEN_WIDTH_THRESHOLD = 1000;
const DEBOUNCE_DELAY = 150;

// Clear all inline height styles
const clearHeightStyles = $slider => {
  $slider.style.height = "";

  const $swiperWrapper = $getSwiperWrapper($slider);
  if ($swiperWrapper) {
    $swiperWrapper.style.height = "";
  }

  const $swiperSlides = $getSwiperSlides($slider);
  $swiperSlides.forEach($slide => {
    $slide.style.height = "";
  });
};

// Apply height after DOM has fully reflowed
const applyMobileHeight = $slider => {
  requestAnimationFrame(() => {
    const naturalHeight = $slider.offsetHeight;

    if (naturalHeight > 0) {
      $slider.style.height = `${naturalHeight}px`;
    }
  });
};

// Lock height for mobile/tablet only (CSS handles desktop)
const lockMobileTabletHeight = () => {
  const $slider = $getSlider();
  if (!$slider) return;

  const screenWidth = window.innerWidth;

  if (screenWidth < SCREEN_WIDTH_THRESHOLD) {
    applyMobileHeight($slider);
  }
};

// Recalculate slider height based on viewport (debounced)
const recalculateSliderHeight = debounce(() => {
  const $slider = $getSlider();
  if (!$slider) return;

  // Clear inline styles first
  clearHeightStyles($slider);

  const screenWidth = window.innerWidth;

  // For mobile/tablet, apply height after reflow
  if (screenWidth < SCREEN_WIDTH_THRESHOLD) {
    applyMobileHeight($slider);
  }
}, DEBOUNCE_DELAY);

export default () => {
  // Initialize mobile/tablet height locking
  lockMobileTabletHeight();

  // Listen for window resize and orientation change
  window.addEventListener("resize", recalculateSliderHeight);

  // Initialize Swiper
  const swiper = new Swiper(".js-hero-carousel", {
    modules: [Autoplay, Navigation],
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".js-hero-carousel-next-button",
      prevEl: ".js-hero-carousel-prev-button"
    }
  });

  // Cleanup function for event listeners
  const cleanup = () => {
    recalculateSliderHeight.cancel();
    window.removeEventListener("resize", recalculateSliderHeight);
  };

  // Store cleanup function on swiper instance for later use if needed
  swiper.cleanup = cleanup;

  return swiper;
};
